import { useEffect, useRef } from 'react';

import { useNavigation } from '@react-navigation/native';

import { useAlerts } from '@/feature/alerts/hooks/use-alerts';
import { PlayerWithTeamAndEvent } from '@/feature/betslip-pickem/types';
import { useSinglePlayerProfile } from '@/feature/fantasy-event-sheets/SinglePlayerProfileProvider';

/**
 * Opens the player profile when landing on the events details sheet via a player deeplink
 */
export const useOpenDeeplinkPlayer = ({
    playerId,
    players,
    isTargetEvent,
}: {
    playerId?: string;
    players: PlayerWithTeamAndEvent[];
    isTargetEvent: boolean;
}) => {
    const { showToast } = useAlerts();
    const { openSinglePlayerProfile, closeSinglePlayerProfile } = useSinglePlayerProfile();
    const navigation = useNavigation();
    const pendingPlayerIdRef = useRef<string | undefined>(playerId);

    if (playerId && playerId !== pendingPlayerIdRef.current) {
        pendingPlayerIdRef.current = playerId;
    }

    useEffect(() => {
        const pendingPlayerId = pendingPlayerIdRef.current;
        if (!isTargetEvent || !pendingPlayerId || players.length === 0) {
            return;
        }

        const deeplinkPlayer = players.find(p => p.id === pendingPlayerId);
        pendingPlayerIdRef.current = undefined;

        if (!deeplinkPlayer) {
            showToast({ message: 'Player unavailable', toastType: 'warning' });
            return;
        }

        openSinglePlayerProfile(deeplinkPlayer);
    }, [isTargetEvent, players, openSinglePlayerProfile, showToast, navigation, closeSinglePlayerProfile]);
};
